import { render, staticRenderFns } from "./StumpageDetails.vue?vue&type=template&id=08cdfa68"
import script from "./StumpageDetails.vue?vue&type=script&lang=js"
export * from "./StumpageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports